import { useLanguage } from '../contexts/LanguageContext';
import { translations, TranslationKeys } from '../locales';
import { Language } from '../types/language';

export const useTranslation = () => {
  const { language } = useLanguage();
  
  const t = (key: string): string => {
    const keys = key.split('.');
    const lang = language as Language;
    let value: any = (translations as Record<string, any>)[lang] || (translations as Record<string, any>)[Language.PL_ONLY];
    
    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        console.warn(`Translation key "${key}" not found for language "${language}"`);
        return key;
      }
    }
    
    return typeof value === 'string' ? value : key;
  };

  return { t, language };
};
